import requester from '@/lib/axios';
import FlashcardActivityProgress, {
  FlashcardAnswerEnum,
} from '@/models/FlashcardActivityProgress';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

const baseUrl = 'flashcard-activity-progress';

export type FlashcardActivityProgressFilters = BaseFilters & {
  lessonId?: number[];
  answer?: FlashcardAnswerEnum[];
};

export const listFlashcardActivityProgress = async (
  params: FlashcardActivityProgressFilters = {},
) => {
  const { data } = await requester().get<
    JsonApiResponse<FlashcardActivityProgress>
  >(`${baseUrl}/`, { params });

  return data;
};
